module.exports = __webpack_public_path__ + "OS_Box_Empty.png?532b41ca575cc2caafbe1469dddccf33";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/OS_Box_Empty.png
// module id = 66
// module chunks = 0